<template>

    <ui-view class="view-action-form" v-spinner="loading" :hide="loading">

        <ui-heading :title="pageTitle">
            <ui-button color="positive" :loading="submitting" @click="$refs.form.submit()">Opslaan</ui-button>
            <ui-button
                color="medium"
                type="bordered"
                :to="backRoute"
                slot="left">Annuleren</ui-button>
        </ui-heading>

        <ui-form-panel auto-validate ref="form" @submit="submit">

            <ui-form-date-input
                title="Datum"
                name="date"
                rules="required"
                v-model="pendingTreatment.date"/>

            <ui-form-input
                title="Behandeling"
                name="treatment"
                rules="required"
                v-model="pendingTreatment.treatment"/>

            <ui-form-input
                number
                title="Duur"
                name="duration"
                suffix="Uur"
                v-model="pendingTreatment.duration"/>

            <ui-form-textarea
                title="Bijzonderheden"
                name="notes"
                v-model="pendingTreatment.notes"/>

        </ui-form-panel>

    </ui-view>

</template>

<script>

import Vue from 'vue';
import moment from 'moment';
import { clone, pick } from 'es-toolkit';
import Component from 'vue-class-component';

import createQuery from 'js-core/js/apollo/queries/createQuery';

import actionTypeTitleFilter from 'common/filters/actionTypeTitle';

import FindTreatmentQuery from 'gql/queries/TreatmentForm/FindTreatment.gql';

import TreatmentMutations from 'app/mutations/TreatmentMutations';

@Component({

    name: 'TreatmentForm',
    apollo: {
        treatment: createQuery(FindTreatmentQuery, {

            skip() {
                return !this.treatmentId;
            },

            variables() {

                return {
                    id: this.treatmentId
                };
            },

            response(response) {

                this.pendingTreatment = pick(response, Object.keys(this.pendingTreatment));
                this.pendingTreatment.date = moment(this.pendingTreatment.date).format('YYYY-MM-DD');
            }
        })
    }
})
export default class TreatmentForm extends Vue
{
    loading = 0;
    submitting = false;

    pendingTreatment = {
        date: null,
        treatment: null,
        duration: null,
        notes: null
    };

    breadcrumb(){

        return [{
            title: 'Vak detail',
            route: this.backRoute
        }, this.pageTitle];
    }

    async submit() {

        this.submitting = true;
        let input = clone(this.pendingTreatment);

        try {

            input.id = this.treatmentId;

            await TreatmentMutations.update(input);

            this.logger.info('Treatment updated');
            this.$toast.success('De behandeling is aangepast');

            this.$router.replace(this.backRoute);
        }
        catch(e) {

            this.logger.error('Error updating treatment', e);
            this.$toast.error('De behandeling kon niet worden opgeslagen');
        }

        this.submitting = false;
    }

    get pageTitle(){

        return this.actionType ? `${this.actionType} wijzigen` : null;
    }

    get actionType(){

        return this.treatment ? actionTypeTitleFilter(this.treatment.__typename, this.treatment) : null;
    }

    get treatmentId(){

        return this.$route.params.id;
    }

    get backRoute(){

        if(!this.treatment){
            return { name: 'sections'};
        }

        return {
            name: 'section-detail',
            params: {
                id: this.treatment.cohort.sectionId
            }
        };
    }
}

</script>